import { combineReducers } from 'redux';
import CatalogoCobroReducer from '../components/admin/CatalogoCobro/CatalogoCobroReducer'
import ReglaNegocioReducer from '../components/admin/ReglaNegocio/ReglaNegocioReducer'
import TutorReducer from '../components/university/Tutor/TutorReducer'
import AlumnoReducer from '../components/university/Students/AlumnoReducer'
import BecasReducer from '../components/admin/Becas/BecasReducer'
import ReglasAutorizadasReducer from '../components/admin/ReglasAutorizadas/ReglasAutorizadasReducer'

import ServiciosAlumnoReducer from '../components/admin/ServiciosAlumno/ServiciosAlumnoReducer'

import ColegiaturasReducer from '../components/admin/Colegiaturas/ColegiaturasReducer'

import GastoCorrienteReducer from '../components/admin/Payments/GastoCorrienteReducer'

import settings from './settings';
import { reducer as formReducer } from 'redux-form'

export default combineReducers({
    settings, CatalogoCobroReducer, ReglaNegocioReducer, TutorReducer, AlumnoReducer, GastoCorrienteReducer, BecasReducer, ReglasAutorizadasReducer, ServiciosAlumnoReducer, ColegiaturasReducer,
    form: formReducer
});